export default __webpack_public_path__ + "static/media/signUpImage.c40a27bb.png";